import React, { Component } from 'react';
import windowSize from 'react-window-size';
import _ from 'lodash';

import './Controller.css';
import { PIXEL_PER_UNIT, TRACK_LENGTH, MAX_FUEL } from '../../consts';
import { Slot } from './Slot/Slot'
import { Level } from './Level/Level'

const chances = _({
  gear: 10,
  dead: 1,
  energy: 10,
  fuel: 15,
  fail: 3
}).map((amount, key) => _.fill(new Array(amount), key)).flatten().value();

class ControllerCore extends Component {
  state = {
    slots: [
      {
        value: 'fuel',
        scroll: false
      },
      {
        value: 'fuel',
        scroll: false
      },
      {
        value: 'fuel',
        scroll: false
      },
    ],
  }
  enemyRoll = () => {
    const { car1, car2, car1Gasoline, car2Gasoline, car1MaxGasoline, car2MaxGasoline } = this.props;
    let values = _.sampleSize(
      [...chances, 
        ...(car2 <= car1 || car2Gasoline < 2 ? _.fill(new Array(20), 'fuel') : []),
        ...(car2 <= car1 ? _.fill(new Array(20), 'energy') : []),
        ...(!car2MaxGasoline ? _.fill(new Array(50), 'gear') : []),
      ],
      3
    );
    if (_.filter(values, value => value == 'fuel').length == 3 && Math.random() > 0.8) {
      values = _.sampleSize(
        [...chances, 
          ...(car2 <= car1 || car2Gasoline < 2 ? _.fill(new Array(20), 'fuel') : []),
          ...(car2 <= car1 ? _.fill(new Array(20), 'energy') : []),
          ...(!car2MaxGasoline ? _.fill(new Array(50), 'gear') : []),
        ],
        3
      );
    }
    this.props.onEnemyRolled && this.props.onEnemyRolled(values);
  }
  onLevelPulled = () => {
    const { car1, car2, car1Gasoline, car2Gasoline, car1MaxGasoline, car2MaxGasoline } = this.props;
    let values = _.sampleSize(
      [...chances, 
        ...(car1 <= car2 || car1Gasoline < 2 ? _.fill(new Array(20), 'fuel') : []),
        ...(car1 <= car2 ? _.fill(new Array(20), 'energy') : []),
        ...(!car1MaxGasoline ? _.fill(new Array(50), 'gear') : []),
      ], 3
    )
    if (_.filter(values, value => value == 'fuel').length == 3 && Math.random() > 0.8) {
      values = _.sampleSize(
        [...chances, 
          ...(car1 <= car2 || car1Gasoline < 2 ? _.fill(new Array(20), 'fuel') : []),
          ...(car1 <= car2 ? _.fill(new Array(20), 'energy') : []),
          ...(!car1MaxGasoline ? _.fill(new Array(50), 'gear') : []),
        ], 3
      )
    }
    values.forEach(this.delaySlot)
    setTimeout(() => {
      this.props.onRolled && this.props.onRolled(values)
      if (!this.enemyAutoRoll) {
        this.enemyAutoRoll = true;
        this.enemyRoll();
        setInterval(this.enemyRoll, 2500)
      }
    }, 300 * 2 + 1500);
  }
  delaySlot = (value, index) => {
    setTimeout(this.setSlot(value, index), 300 * index);
    setTimeout(this.stopSlot(value, index), 300 * index + 1000);
  }
  setSlot = (value, index) => () => {
    this.setState(state => {
      const slots = state.slots.slice();
      slots[index] = {value, scroll: true};
      return {
        slots
      }
    })
  }
  stopSlot = (value, index) => () => {
    this.setState(state => {
      const slots = state.slots.slice();
      slots[index] = {value, scroll: false};
      return {
        slots
      }
    })
  }
  render() {
    const {
      slots,
    } = this.state;
    const {
      car1, car2,
      car1Gasoline,
      car2Gasoline,
      car1MaxGasoline,
      car2MaxGasoline,
    } = this.props;
    
    return (
      <div className="controller">
        <div className="hud">
          <div className="slots">
            { slots.map((slot, index) => (
              <Slot {...slot} key={index}/>
            )) }
          </div>
          <div className="hud-panel"/>
          <div className="needle car1" style={{
            transform: `rotate(${(car1Gasoline / MAX_FUEL) * 90 - 45}deg)`
          }}/>
          <div className="needle car2" style={{
            transform: `rotate(${(car2Gasoline / MAX_FUEL) * 90 - 45}deg)`
          }}/>
          <div className="trace car1" style={{
            transform: `translateX(${(car1 / TRACK_LENGTH) * 260}px)`
          }}/>
          <div className="trace car2" style={{
            transform: `translateX(${(car2 / TRACK_LENGTH) * 260}px)`
          }}/>
          <div className="engine car1" style={{
            backgroundPositionX: getEnginePosition(car1MaxGasoline/MAX_FUEL)
          }}/>
          <div className="engine car2" style={{
            backgroundPositionX: getEnginePosition(car2MaxGasoline/MAX_FUEL)
          }}/>
          <Level onClick={this.onLevelPulled}/>
        </div>
      </div>
    );
  }
}

function getEnginePosition(port) {
  if (port > 0.7) {
    return '0%'
  } else if (port > 0.4) {
    return '33%'
  } else if (port > 0.4) {
    return '67%'
  } else {
    return '100%'
  }
}

export const Controller = windowSize(ControllerCore);


// WEBPACK FOOTER //
// ./src/components/Controller/Controller.js